import styled from '@emotion/styled';

import { Colors } from '../../constants';

namespace ColumnLayout {
  export const Container = styled.div`
    width: 100%;
    max-width: 1080px;
    height: 100%;

    margin-left: auto;
    margin-right: auto;

    display: flex;
  `;

  export const Large = styled.div`
    width: 72%;
    height: 100%;

    padding-left: 2.5rem;
    padding-right: 2.5rem;

    border-right: 1px solid ${Colors.Container.border};

    @media (max-width: 750px) {
      width: 100%;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      border-right: none;
    }
  `;

  export const Small = styled.div`
    width: 28%;
    height: 100%;

    padding-left: 1.5rem;
    padding-right: 1.5rem;

    @media (max-width: 750px) {
      display: none;
    }
  `;
}

export default ColumnLayout;
